import { ca } from '@cian/analytics';
import { TDeviceType } from '@cian/ui-kit/types/TDeviceType';

export function trackShow(objectId: number, reason: string | null | undefined, deviceType: TDeviceType) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'DailyrentReviews',
    action: 'show',
    label: 'Write_Open_Restriction',
    page: {
      pageType: 'ReviewsDailyrent',
      siteType: deviceType === 'desktop' ? 'desktop' : 'mobile',
      extra: { reason },
    },
    products: [{ id: objectId, offerType: 'offer' }],
  });
}
